export const swapArrayElements = (myArray: any[], index1: number, index2: number) => {
  myArray[index1] = myArray.splice(index2, 1, myArray[index1])[0];
};
